<template>
  <v-dialog
    v-if="!$apollo.loading && !_.isEmpty(viewKeySecret)"
    v-model="keySecretDialog"
    width="550"
    persistent
  >
    <v-card>
      <v-card-title
        class="header"
        primary-title
      >
        <b>{{ $t('investors.viewKeySecret') }}</b>
      </v-card-title>
      <v-card-text
        class="data mt-5"
      >
        {{ $t('investors.viewKeyText') }}
        <v-layout wrap>
          <v-flex
            md12
            sm12
            xs12
            mt-5
          >
            <v-text-field
              name="apikey"
              :label="$t('accounts.key')"
              :value="viewKeySecret.key"
              readonly
              @focus="$event.target.select()"
            >
              <template v-slot:append>
                <v-icon
                  v-clipboard:copy="viewKeySecret.key"
                  style="cursor:pointer;"
                >
                  mdi-content-copy
                </v-icon>
              </template>
              <template v-slot:prepend>
                <v-icon>
                  mdi-key
                </v-icon>
              </template>
            </v-text-field>
            <v-text-field
              name="secret"
              :label="$t('accounts.secret')"
              :value="viewKeySecret.secret"
              :type="showSecret ? 'text' : 'password'"
              readonly
              @focus="$event.target.select()" 
            >
              <template v-slot:append>
                <v-icon
                  v-clipboard:copy="viewKeySecret.secret"
                  style="cursor:pointer;"
                >
                  mdi-content-copy
                </v-icon>
              </template>
              <template v-slot:prepend>
                <v-icon
                  style="cursor:pointer;"
                  @click="showSecret = !showSecret"
                >
                  {{ showSecret ? 'mdi-eye' : 'mdi-eye-off' }}
                </v-icon>
              </template>
            </v-text-field>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          :disabled="loading"
          @click="keySecretDialog = false"
        >
          {{ $t('globals.closeButton') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import VIEW_KEY_SECRET_QUERY from "@/graphql/queries/ViewKeySecret.gql";

export default {
  name: "ViewKeyDialog",
  props: {
    connectionId: {
      type: Number,
      default: null
    },
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      showSecret: false,
      viewKeySecret: null
    };
  },
  computed: {
    keySecretDialog: {
      get() {
        return this.showDialog;
      },
      set(val) {
        this.$parent.keySecretDialog = val;
      }
    }
  },
  apollo: {
    viewKeySecret: {
      query: VIEW_KEY_SECRET_QUERY,
      variables() {
        return {
          id: this.connectionId
        };
      },
      result(data) {
        if (!data.loading && data.error) {
          this.$parent.keySecretDialog = false;
        }
      }
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.data {
  span {
    font-size: 12px;
    font-weight: 600;
    color: #7f97ab;
    text-transform: uppercase;
  }
  p {
    font-size: 16px;
    font-weight: 700;
    color: #000;
  }
  small {
    font-size: 13px;
    line-height: 16px;
    display: inline-block;
  }
}
</style>
